import React from "react";
import "./Footer.css";
import Logo from "../components/logo1.png"; // Ensure the path to the logo is correct
import { Mail, Phone } from "lucide-react"; // Import icons from lucide-react

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer">
  <div className="footer-content">
    <h3>Contact Us</h3>
    <div className="logo-container">
      <img src={Logo} alt="Logo" className="footer-logo" />
      <span className="logo-text">TISSAA</span>
    </div>
    <p>
      2WV6+VXH, VN Purav Marg, <br />
      Deonar, Chembur, Mumbai, <br />
      Maharashtra 400088
    </p>
    <div className="contact">
      <p>
        <Mail size={16} /> <a href="mailto:tissa2013@gmail.com">tissa2013@gmail.com</a>
      </p>
      <p>
        <Phone size={16} /> <a href="tel:+919021612549">+91 9021612549</a>
      </p>
    </div>
  </div>
  <div className="footer-bottom">
    <p className="copyright">© 2025 TISSAA</p>
    <p className="developer">Developed by - TISSAA Tech Team</p>
  </div>
</div>

    </footer>
  );
};

export default Footer;
